import { FC, useMemo } from 'react';
import {
  Box,
  Button,
  Heading,
  Icon,
  VStack,
  Wrap,
  WrapItem,
} from '@chakra-ui/react';
import { ParagraphFocusTagGlossaryFragment } from '../../../generated/types';
import groupBy from 'lodash/groupBy';
import sortBy from 'lodash/sortBy';
import Link from 'next/link';
import scrollToElement from '../../../utils/scrollToElement';

interface FocusTagGlossaryProps {
  data: ParagraphFocusTagGlossaryFragment;
}

export const FocusTagGlossary: FC<FocusTagGlossaryProps> = ({ data }) => {
  const groupedArticles = useMemo(() => {
    const groupedData = groupBy(
      data.data.items.filter((article) => !article.tag.hideInList),
      (article) => article.tag.title.at(0)?.toUpperCase()
    );

    for (let [key, value] of Object.entries(groupedData)) {
      groupedData[key] = sortBy(
        groupedData[key].filter((article) => !article.tag.hideInList),
        [(article) => article.tag.title]
      );
    }

    return groupedData;
  }, [data]);

  return (
    <Box>
      <Wrap mb={6}>
        {Object.keys(groupedArticles)
          .sort()
          .map((key, index) => {
            return (
              <WrapItem key={`button-${key}`}>
                <Button
                  variant="outline"
                  onClick={() => {
                    scrollToElement(`#key-${key}`);
                  }}
                >
                  {key}
                </Button>
              </WrapItem>
            );
          })}
      </Wrap>

      <VStack alignItems="flex-start" spacing={6}>
        {Object.keys(groupedArticles)
          .sort()
          .map((key, index) => {
            const articles = groupedArticles[key];

            return (
              <Box key={key!} id={`key-${key}`}>
                <Box fontSize="xl" color="primary" fontWeight="bold">
                  {key}
                </Box>
                <VStack alignItems="flex-start" ml={4}>
                  {articles.map((article) => (
                    <Box key={article.id}>
                      <Link href={article.url} passHref>
                        <Box
                          as="a"
                          _hover={{
                            textDecoration: 'underline',
                          }}
                        >
                          {article.tag.title}
                        </Box>
                      </Link>
                    </Box>
                  ))}
                </VStack>
              </Box>
            );
          })}
      </VStack>
    </Box>
  );
};
